import config from "../../config"
import RequestService from "../RequestService"

const fetchEquipmentItems = (successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/equipment_items`, successCallback, failureCallback)
}

export default fetchEquipmentItems;